var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_13051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.66667C0 1.19391 1.19391 0 2.66667 0H16C20.4183 0 24 3.58172 24 8V24C24 25.4728 22.8061 26.6667 21.3333 26.6667H2.66667C1.19391 26.6667 0 25.4728 0 24V2.66667Z",
    fill: "url(#paint0_linear_208_13051)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1589 17.2112V15.8788H17.8961V17.2112H15.8379V22.6667H14.2205V17.2112H12.1589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72166 15.8788L8.23965 20.8504H8.29599L9.81399 15.8788H11.6502L9.35991 22.6667H7.17573L4.88548 15.8788H6.72166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71486 1.85796C5.68344 1.96368 5.64915 2.07053 5.61258 2.17568L5.59772 2.21853L10.6834 3.99396L10.7263 4.00882L10.7411 3.96596C10.808 3.77453 10.8709 3.5791 10.928 3.38539L10.9412 3.34196L5.73029 1.8151L5.71486 1.85796Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4177 4.25458C4.33656 4.35001 4.25027 4.44543 4.1617 4.54029L4.13027 4.57286L8.0457 8.33972L8.07713 8.30715C8.23942 8.13858 8.3977 7.96429 8.54742 7.78715L8.57656 7.75286L4.44742 4.222L4.4177 4.25458Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7749 4.90822C3.6749 4.99621 3.5709 5.0825 3.46575 5.16421L3.42975 5.19221L6.74804 9.43907L6.77604 9.4745L6.81147 9.4465C7.00347 9.29679 7.19204 9.14021 7.37204 8.98079L7.40575 8.95107L3.80861 4.87793L3.7749 4.90822Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.24393 5.91501C2.11593 5.97558 1.98678 6.02929 1.85936 6.08244L1.80736 6.10301L3.79936 11.1144L3.81707 11.1544L3.97307 11.0922L4.1845 11.003C4.31878 10.9459 4.45307 10.8842 4.5845 10.8219L4.62564 10.8024L2.2845 5.89844L2.24393 5.91501Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96 3.51958C4.89657 3.619 4.82971 3.71843 4.75543 3.823L4.72914 3.85958L9.104 7.00243L9.14114 7.02872L9.16743 6.99215C9.29771 6.81043 9.424 6.623 9.54343 6.435L9.56743 6.39672L4.984 3.48243L4.96 3.51958Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04286 5.46757C2.92857 5.54357 2.808 5.61615 2.688 5.68415L2.64857 5.70643L5.35771 10.4184L5.39714 10.3961C5.61714 10.2704 5.83543 10.1367 6.04514 9.99615L6.08286 9.971L3.08057 5.44472L3.04286 5.46757Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.39371 6.247C1.25543 6.29043 1.108 6.32986 0.963428 6.36529L0.919429 6.37557L2.18457 11.6664L2.22857 11.6567C2.28034 11.6449 2.33217 11.6321 2.384 11.6184L2.42686 11.6076L2.41257 11.5504C2.61714 11.5121 2.81771 11.467 3.01029 11.4161L3.056 11.4041L1.43657 6.23672L1.39371 6.247Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39586 2.71603C5.34786 2.82117 5.29644 2.92688 5.24329 3.03031L5.22272 3.07031L10.0422 5.57374L10.0627 5.53374C10.1604 5.34403 10.2553 5.15031 10.3427 4.95717L10.3616 4.91603L5.41529 2.67546L5.39586 2.71603Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98129 0V0.045142C5.98129 0.145142 5.97786 0.246857 5.97272 0.346285V0.391428L11.3967 0.673714V0.62857C11.4064 0.446856 11.4121 0.262285 11.4127 0.0788563V0.0337132L5.98129 0Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91261 0.961317C5.89718 1.06589 5.8789 1.17103 5.8589 1.27446L5.85033 1.31903L11.1783 2.36475L11.1869 2.32075C11.2235 2.13789 11.2566 1.94589 11.2858 1.74932L11.2926 1.70475L5.92118 0.917318L5.91261 0.961317Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.505713 6.45729C0.353142 6.48243 0.197713 6.50243 0.045142 6.51443L0 6.51843L0.469713 11.6316L0.497142 11.9407L0.542285 11.9367C0.605714 11.931 0.667999 11.9247 0.731428 11.9179L0.776571 11.9133L0.752 11.6813C0.952 11.6859 1.15486 11.6813 1.356 11.6721H1.40628L0.549142 6.45043L0.505713 6.45729Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_13051",
    x1: 0.666667,
    y1: 0.606061,
    x2: 20.7396,
    y2: 28.5311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF49F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451923,
    stopColor: "#6C42DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08011B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_13051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26.6667,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vt.48f68dc66bc108a511d239573b117568.svg";